// removed by extract-text-webpack-plugin
module.exports = {"councilWrapper":"council-map-module__councilWrapper___zrMgh","mapWrapper":"council-map-module__mapWrapper___18cO6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/council-map-container/council-map.module.scss
// module id = 630
// module chunks = 0 1